import {getDataError, handleGetUserData, handleLogOutUser, requestData} from "./splashSlice";

export async function getUserData(dispatch) {
    try {
        console.log('error')
        dispatch(requestData());
        dispatch(handleGetUserData())
    } catch (error) {
        dispatch(getDataError())
    }
}

export function logOutUser(dispatch) {
    dispatch(handleLogOutUser());
    localStorage.removeItem('userData');
    window.location.reload();
}

